import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ToolbarRadio, ToolbarDivider } from '../toolbar';

export type InvoicesView = 'invoices' | 'line-items';

/**
 * "Invoices | Line items" — the first controls in both pages' toolbars.
 * The invoice list is the layout's `invoices` view at `/`; the Line Item
 * Explorer is the URL route `/invoices/line-items` (MainLayout keeps the
 * Invoices nav tab active on it), so either can be bookmarked.
 */
export const InvoicesViewSwitch: React.FC<{ active: InvoicesView }> = ({ active }) => {
  const navigate = useNavigate();
  return (
    <>
      <ToolbarRadio
        name="invoices-view"
        label="Invoices"
        active={active === 'invoices'}
        onClick={() => active !== 'invoices' && navigate('/')}
      />
      <ToolbarRadio
        name="invoices-view"
        label="Line items"
        active={active === 'line-items'}
        onClick={() => active !== 'line-items' && navigate('/invoices/line-items')}
      />
      <ToolbarDivider />
    </>
  );
};
